import { Box } from "@mui/system";
import React, { useEffect } from "react";
export const PageSection = ({
    children,
    backgroundColor = "background.default",
}) => {
    return (
        <Box
            sx={{
                backgroundColor,
                animation: "fadeInFromNone  480ms ease-out",
            }}
            element="section"
        >
            {children}
        </Box>
    );
};
